import React from "react";
import "./HorizontalLine.scss";

function HorizontalLine(Vrline) {
  return <div className={Vrline ? "VrLine" : "hrLine"}></div>;
}

export default HorizontalLine;
